import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {
  AuthGuardLogged
} from '../../domains/auth/guards';


import { DashboardContainerComponent } from './containers';

const routes: Routes = [
  {
    path: '',
    component: DashboardContainerComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'companies' },
      {
        path: 'sales',
        loadChildren: () =>
          import('../sales/sales.module').then(m => m.SalesModule)
      }, {
        path: 'companies',
        loadChildren: () =>
          import('../companies/companies.module').then(m => m.CompaniesModule)
      }, {
        path: 'numbers',
        loadChildren: () =>
          import('../numbers/numbers.module').then(m => m.NumbersModule)
      }, {
        path: 'equipment',
        loadChildren: () =>
          import('../equipment/equipment.module').then(m => m.EquipmentModule)
      }, {
        path: 'internal-facilities',
        loadChildren: () =>
          import('../internal-facilities/internal-facilities.module').then(m => m.InternalFacilitiesModule)
      }, {
        path: 'kpi',
        loadChildren: () =>
          import('../kpi/kpi.module').then(m => m.KpiModule)
      }, {
        path: 'reviews',
        loadChildren: () =>
          import('../reviews/reviews.module').then(m => m.ReviewsModule)
      }, {
        path: 'integrations',
        loadChildren: () =>
        import('../integrations/integrations.module').then(m => m.IntegrationsModule)
      }, {
        path: 'marketing',
        loadChildren: () =>
          import('../marketing/marketing.module').then(m => m.MarketingModule)
      }, {
        path: '',
        redirectTo: '',
        pathMatch: 'full',
        canActivate: [AuthGuardLogged]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
